// Most used e-mail providers in France: suggestions after "@" and typo detection.
export const EMAIL_DOMAINS = [
  "gmail.com", "orange.fr", "hotmail.fr", "hotmail.com", "outlook.fr", "outlook.com", "yahoo.fr", "yahoo.com",
  "free.fr", "sfr.fr", "laposte.net", "wanadoo.fr", "live.fr", "live.com", "icloud.com", "me.com", "msn.com",
  "bbox.fr", "neuf.fr", "aol.com", "gmx.fr", "protonmail.com", "proton.me", "numericable.fr", "club-internet.fr",
  "aliceadsl.fr", "cegetel.net", "noos.fr", "voila.fr", "mail.com",
];

const dist = (a, b) => {
  const d = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 1; j <= b.length; j++) d[0][j] = j;
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    }
  }
  return d[a.length][b.length];
};

export const domainSuggestions = (email) => {
  const at = email.indexOf("@");
  if (at < 1) return [];
  const [user, typed] = [email.slice(0, at), email.slice(at + 1).toLowerCase()];
  return EMAIL_DOMAINS.filter((d) => d.startsWith(typed) && d !== typed).slice(0, 5).map((d) => `${user}@${d}`);
};

export const typoFix = (email) => {
  const at = email.lastIndexOf("@");
  const dom = email.slice(at + 1).toLowerCase();
  if (at < 1 || !dom || EMAIL_DOMAINS.includes(dom)) return null;
  const best = EMAIL_DOMAINS.map((d) => [d, dist(dom, d)]).sort((a, b) => a[1] - b[1])[0];
  return best[1] > 0 && best[1] <= 2 ? `${email.slice(0, at)}@${best[0]}` : null;
};
